export enum Selectors {
    productsView = 0,
    selectProductsView = 1
}
